import React from 'react'
import Layout from '../../components/wrappers/Layout'
import PageHeadingRow from '../../components/molecules/PageHeadingRow'
import useScrollToTop from '../../utils/scrollToTop'
import { Helmet } from 'react-helmet'
import Container from 'react-bootstrap/Container'
import text from '../../_constants/text'
import BillingGuideLookupDisclaimer from './BillingGuideLookupDisclaimer'
import BillingGuideLookupForm from './BillingGuideLookupForm'
import BillingGuideLookupAssociations from './BillingGuideLookupAssociations'

const BillingGuideLookupPage: React.FC = () => {
  useScrollToTop()

  return (
    <Layout>
      <Helmet>
        <title>{text.BILLING_GUIDE_LOOKUP}</title>
      </Helmet>
      <section className="billing-guide-lookup-page justify-content-center content-background content-background-min-height">
        <Container className="px-xl-0 pb-5 max-grid-width d-flex flex-column" fluid>
          <PageHeadingRow title={text.BILLING_GUIDE_LOOKUP} />

          <BillingGuideLookupDisclaimer />

          <BillingGuideLookupForm />

          <BillingGuideLookupAssociations />
        </Container>
      </section>
    </Layout>
  )
}

export default BillingGuideLookupPage
